export const SearchSuggestions: string[] = [
  "Halaal in <strong>Services - Food and Beverages</strong>",
  "SnapScan in <strong>Services - Payment Options</strong>",
  "Kosher in <strong>Services - Food and Beverages</strong>",

  "Bride & Co in <strong>Speciality Stores - Wedding</strong>",
  "Anniversary gift in <strong>Speciality Stores - Gifts for Her</strong>",

  "Nike in <strong>Brands - Sport</strong>",
  "Apple in <strong>Brands - Technology</strong>",
  "Calvin Klein in <strong>Brands - Luxury</strong>",

  "Baking Supplies in <strong>Products - Groceries</strong>",
  "Pet Food in <strong>Products - Pet Care</strong>",
  "Water Toys in <strong>Products - Outdoor Play</strong>",

  "Edgars in <strong>Stores</strong>",
  "Mr Price in <strong>Stores</strong>",
  "Homemark in <strong>Stores</strong>",
];
